import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import style from "./forum.module.scss";
import toPersianNumber from "../../helpers/actions/toPersianNumber"
import Skeleton from "../wallet/skeleton"
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown"
import Pagination from "../pagination/pagination"
import ForumCard from './forumCard/forumCard'
import CommentModal from "./commentModal/commentModal"
import { GetTweetsList, LikeRequest, CommentOnRequest, GetCommentsOnRequest, DeleteTweet } from "../../actions/APIcalls"


const Forum = (props) => {

    const [requestData, setRequestData] = useState({
        requestsList: [],
        totalRequests: 1,
        totalPages: 1,
        loading: true,
        likedRequests: []
    })

    const [commentModal, setCommentModal] = useState({
        open: false,
        data: null
    })

    useEffect(() => {
        getAllRequests()
        // deleteLastTweet()
    }, [])

    const deleteLastTweet = async () => {
        let id = ''
        let res = await DeleteTweet(id)
    }

    const getAllRequests = async () => {
        setRequestData({ ...requestData, loading: true })
        let params = {
            page: getFromUrl('page') || 1,
            sortBy: 'createdAt',
            limit: getFromUrl('countInPage') || 10,
            category: 'ویژگی جدید'
        }
        let res = await GetTweetsList(params)
        let tmp = requestData
        if (res && res.data && res.data.tweetData.length > 0) {
            tmp.requestsList = res.data.tweetData
            tmp.totalPages = res.data.totalPages
            tmp.totalRequests = res.data.totalTweet
        }
        tmp.loading = false
        setRequestData({ ...tmp })
    }

    const getFromUrl = (param) => {
        const defaultParams = {
            countInPage: 10,
            page: 1,
        }
        let url = new URLSearchParams(window.location.search);
        if (url.get(param)) {
            if (url.get(param) === "true" || url.get(param) === "false") {
                return url.get(param) === "true" ? true : false;
            } else {
                return url.get(param)
            }
        } else {
            return defaultParams[param];
        }
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        getAllRequests();
    }

    const handleLike = async (id) => {
        if (!requestData.likedRequests.includes(id)) {
            // prevent multiple likes from one user
            let tmp = requestData
            tmp.likedRequests.push(id)
            setRequestData({ ...tmp })
            // request to like
            let res = await LikeRequest(id)
        }
    }

    const handleComment = async (request, page) => {
        let res = await GetCommentsOnRequest({ id: request._id, page: page })
        if (res && res.data) {
            let tmp = commentModal
            tmp.open = true
            tmp.data = {
                ...request,
                comments: res.data.commentData || [],
                page: res.data.page,
                totalPages: res.data.totalPages || 1,
                totalComment: res.data.totalComment || 1,
            }
            setCommentModal({ ...tmp })
        }
    }

    const addComment = async (data) => {
        let res = await CommentOnRequest(data)

        return res
    }

    if (requestData.loading) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <div className={style.header}>
                    <h1>انجمن</h1>
                </div>

                <CommentModal
                    value={commentModal.open}
                    data={commentModal.data}
                    parentClose={() => setCommentModal({ ...commentModal, open: false })}
                    addComment={addComment}
                    getComments={handleComment}
                />

                {/* pagination */}
                <div className={style.paginationWrapper}>
                    <div className={style.pagination}>
                        <div className={style.Dropdown}>
                            <Pagination
                                tag="page"
                                currentPage={parseInt(getFromUrl("page"))}
                                pageCount={requestData.totalPages}
                                setPage={setToUrl}
                            />
                            <div className={style.gap20}></div>
                            <TinyDropdown
                                placeholder={10}
                                dropdownList={["10", "25", "50", "75", "100"]}
                                selected={selected => {
                                    setToUrl(selected, 'countInPage')
                                }}
                                selectedItem={getFromUrl('countInPage')}
                            />
                            <div className={style.label}>تعداد نمایش در صفحه</div>
                            <div className={style.verticalLine}></div>
                            <div
                                className={style.variantCount}>{typeof requestData.totalRequests !== 'undefined' ? toPersianNumber(requestData.totalRequests) + " نتیجه" : ""}</div>
                        </div>
                    </div>
                </div>
                {/* pagination */}

                {requestData.requestsList.length > 0 && <div className={style.tableWrapper}>
                    {requestData.requestsList.map((request, requestIndex) => <ForumCard
                        handleLike={handleLike}
                        handleComment={handleComment}
                        key={`requestIndex_${requestIndex}`}
                        data={request} />)}
                </div>}

                <div className={style.paginationTwo}>
                    <Pagination
                        tag="page"
                        currentPage={parseInt(getFromUrl("page"))}
                        pageCount={requestData.totalPages}
                        setPage={setToUrl}
                    />
                </div>
            </div>
        )
    }
}

export default withRouter(Forum);
